import { gql } from '@common/hooks';
import { HistoryInfoFragment, HistoryInfoFragmentType } from '@common/graphql';
import { InvoiceReviewFragmentType, InvoiceStateType } from './invoice';

export const ReverseInvoiceListItemFragment = gql`
  fragment ReverseInvoiceListItemFragment on WorksReverseInvoice {
    id
    code
    totalCents
    worksInvoice {
      id
      state
      due
    }
    openedDisputeCount
    createdAt
    organization {
      id
      name
    }
  }
`;

export type ReverseInvoiceListItemFragmentType = {
  id: string;
  code: string;
  totalCents: number;
  worksInvoice: {
    id: string;
    state: InvoiceStateType;
    due: string;
  };
  openedDisputeCount: number;
  createdAt: string;
  organization: {
    id: string;
    name: string;
  };
};

export const ReverseInvoiceReviewFragment = gql`
  fragment ReverseInvoiceReviewFragment on WorksReverseInvoice {
    id
    code
    totalCents
    totalHours
    effectiveHourlyRateCents
    mspFee
    mspFeePercentage
    tierFee
    tierFeePercentage
    totalRemittanceCents
    totalMspCents
    totalTierCents
    createdAt
    disputesDifferential
    disputesCountByState {
      state
      count
    }
    worksInvoice {
      id
      code
      due
      totalCents
      totalHours
      payPeriodStartDate
      payPeriodEndDate
      defaultToBillingAddress
      defaultRemitToBillingAddress
      defaultRemitPaymentInfo
      state
      stateChangedAt
      preCalculated
      createdAt
      canSubmitDispute {
        value
      }
      organization {
        id
        name
        payCodes
      }
    }
    history {
      ...HistoryInfoFragment
    }
  }
  ${HistoryInfoFragment}
`;

export type ReverseInvoiceReviewFragmentType = {
  id: string;
  code: string;
  totalCents: number;
  totalHours: number;
  effectiveHourlyRateCents: number;
  mspFee: boolean;
  mspFeePercentage: number;
  tierFee: boolean;
  tierFeePercentage: number;
  totalRemittanceCents: number;
  totalMspCents: number;
  totalTierCents: number;
  createdAt: string;
  disputesDifferential: number;
  disputesCountByState: [
    {
      state: string;
      count: number;
    },
  ];
  worksInvoice: InvoiceReviewFragmentType;
  history: HistoryInfoFragmentType[];
};
